/* Ellerbe Woods — scroll direction (Shopify port) */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 820px)').matches;
  var lenis = null;
  var tickers = [];

  function addTicker(fn) { gsap.ticker.add(fn); tickers.push(fn); }

  function teardown() {
    if (window.ScrollTrigger) ScrollTrigger.getAll().forEach(function (t) { t.kill(); });
    tickers.forEach(function (fn) { gsap.ticker.remove(fn); });
    tickers = [];
  }

  function initNav() {
    var nav = document.getElementById('nav');
    var heroEl = document.getElementById('hero');
    if (!nav) return;
    function navState() {
      var y = window.scrollY;
      nav.classList.toggle('scrolled', y > 40);
      if (heroEl) nav.classList.toggle('past-hero', y > heroEl.offsetHeight - innerHeight);
      else nav.classList.add('past-hero');
    }
    addEventListener('scroll', navState, { passive: true });
    navState();
  }

  function initReduced() {
    var video = document.getElementById('heroVideo');
    var sticky = document.querySelector('.hero-sticky');
    if (!video || !sticky) return;
    var lit = sticky.getAttribute('data-poster-lit');
    video.remove();
    if (lit) {
      var img = new Image();
      img.src = lit;
      img.alt = 'Ellerbe Woods candle burning in its concrete vessel';
      img.className = 'hero-video';
      img.style.objectFit = 'cover';
      sticky.prepend(img);
    }
  }

  function initHero() {
    var video = document.getElementById('heroVideo');
    var heroEl = document.getElementById('hero');
    if (!video || !heroEl) return;

    var src = mobile ? video.getAttribute('data-src-mobile') : video.getAttribute('data-src-desktop');
    if (!src) return;
    var videoReady = false;

    fetch(src)
      .then(function (r) { return r.blob(); })
      .then(function (b) {
        video.src = URL.createObjectURL(b);
        video.load();
        video.addEventListener('loadedmetadata', function () { videoReady = true; }, { once: true });
      })
      .catch(function () { video.src = src; video.load(); videoReady = true; });

    var targetT = 0, currentT = 0;
    var cueFill = document.getElementById('cueFill');
    var cue = document.getElementById('scrollCue');
    var CUE_LEN = 132;

    ScrollTrigger.create({
      trigger: '#hero',
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      onUpdate: function (self) {
        var p = Math.min(self.progress / 0.82, 1);
        targetT = p;
        if (cueFill) cueFill.style.strokeDashoffset = String(CUE_LEN * (1 - p));
        if (cue) gsap.set(cue, { autoAlpha: self.progress > 0.78 ? 0 : 1 });
      }
    });

    addTicker(function () {
      if (!videoReady || !video.duration) return;
      currentT += (targetT - currentT) * 0.12;
      var t = currentT * (video.duration - 0.05);
      if (Math.abs(video.currentTime - t) > 0.01) video.currentTime = t;
    });

    if (document.querySelector('#heroCopy')) {
      gsap.timeline({
        scrollTrigger: { trigger: '#hero', start: 'top top', end: 'bottom bottom', scrub: 0.6 }
      })
        .to('.hero-copy .eyebrow', { opacity: 1, duration: 0.06 }, 0.05)
        .to('.hero-title', { opacity: 1, duration: 0.12 }, 0.09)
        .to('.hero-sub', { opacity: 1, duration: 0.08 }, 0.2)
        .to('#heroCopy', { yPercent: -6, duration: 0.5 }, 0.35)
        .to('#heroCopy', { opacity: 0, duration: 0.15 }, 0.86);

      if (!mobile) {
        var copy = document.getElementById('heroCopy');
        var mx = 0, my = 0, cx = 0, cy = 0;
        addEventListener('pointermove', function (e) {
          mx = (e.clientX / innerWidth - 0.5) * 14;
          my = (e.clientY / innerHeight - 0.5) * 8;
        });
        addTicker(function () {
          cx += (mx - cx) * 0.06;
          cy += (my - cy) * 0.06;
          copy.style.setProperty('translate', cx + 'px ' + cy + 'px');
        });
      }
    }
  }

  function initParallaxAndScene() {
    gsap.utils.toArray('[data-prlx] img').forEach(function (img) {
      gsap.fromTo(img, { yPercent: -6 }, {
        yPercent: 6, ease: 'none',
        scrollTrigger: { trigger: img.closest('figure, .close-bg'), start: 'top bottom', end: 'bottom top', scrub: true }
      });
    });
    gsap.utils.toArray('#sceneLines .line').forEach(function (line) {
      gsap.fromTo(line, { opacity: 0.14 }, {
        opacity: 1, ease: 'none',
        scrollTrigger: { trigger: line, start: 'top 82%', end: 'top 45%', scrub: true }
      });
    });
  }

  function initNotes() {
    var panels = gsap.utils.toArray('.note-panel');
    var notesEl = document.getElementById('notes');
    if (!panels.length || !notesEl) return;

    var NOTES = panels.map(function (p) {
      return { stage: p.getAttribute('data-stage') || '', name: p.getAttribute('data-name') || '', line: p.getAttribute('data-line') || '' };
    });
    var N = panels.length;
    var stageEl = document.getElementById('noteStage');
    var nameEl = document.getElementById('noteName');
    var lineEl = document.getElementById('noteLine');
    var idxEl = document.getElementById('idxCurrent');
    var fillEl = document.getElementById('idxFill');
    var activeNote = -1;

    gsap.set(panels[0], { opacity: 1 });

    function setNote(i) {
      if (i === activeNote) return;
      activeNote = i;
      var n = NOTES[i];
      gsap.timeline()
        .to([stageEl, nameEl, lineEl], { opacity: 0, y: -8, duration: 0.18, ease: 'power1.in' })
        .add(function () {
          if (stageEl) stageEl.textContent = n.stage;
          if (nameEl) nameEl.textContent = n.name;
          if (lineEl) lineEl.textContent = n.line;
          if (idxEl) idxEl.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        })
        .to([stageEl, nameEl, lineEl], { opacity: 1, y: 0, duration: 0.3, ease: 'power2.out' });
    }

    ScrollTrigger.create({
      trigger: '#notes',
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      onUpdate: function (self) {
        var p = self.progress;
        if (fillEl) fillEl.style.width = (p * 100).toFixed(1) + '%';
        var seg = Math.min(Math.floor(p * N), N - 1);
        setNote(seg);
        panels.forEach(function (panel, i) {
          var segP = gsap.utils.clamp(0, 1, p * N - i);
          var o = 0;
          if (i === seg) o = 1;
          if (i === seg + 1) o = gsap.utils.clamp(0, 1, (p * N - i + 0.18) / 0.18);
          gsap.set(panel, { opacity: i <= seg ? 1 : o });
          var im = panel.querySelector('img');
          if (im) gsap.set(im, { scale: 1.12 - segP * 0.08 });
        });
      }
    });
  }

  function initCraft() {
    gsap.utils.toArray('.craft-item').forEach(function (item) {
      gsap.fromTo(item, { opacity: 0, y: 28 }, {
        opacity: 1, y: 0, duration: 0.7, ease: 'power2.out',
        scrollTrigger: { trigger: item, start: 'top 86%' }
      });
    });
    var card = document.getElementById('craftCard');
    if (!mobile && card) {
      var rx = 0, ry = 0, tx = 0, ty = 0;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * 7;
        ty = ((e.clientY - r.top) / r.height - 0.5) * -7;
      });
      card.addEventListener('pointerleave', function () { tx = 0; ty = 0; });
      addTicker(function () {
        rx += (ty - rx) * 0.08; ry += (tx - ry) * 0.08;
        card.style.transform = 'perspective(48rem) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
      });
    }
  }

  function initFades() {
    gsap.utils.toArray('.ritual-title, .ritual-body, .close-title').forEach(function (el) {
      gsap.fromTo(el, { opacity: 0, y: 24 }, {
        opacity: 1, y: 0, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%' }
      });
    });
  }

  function initMagnetic() {
    if (mobile) return;
    document.querySelectorAll('.btn-add').forEach(function (btn) {
      var bx = 0, by = 0, gx = 0, gy = 0;
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        gx = (e.clientX - r.left - r.width / 2) * 0.22;
        gy = (e.clientY - r.top - r.height / 2) * 0.32;
      });
      btn.addEventListener('pointerleave', function () { gx = 0; gy = 0; });
      addTicker(function () {
        bx += (gx - bx) * 0.12; by += (gy - by) * 0.12;
        btn.style.transform = 'translate(' + bx.toFixed(1) + 'px, ' + by.toFixed(1) + 'px)';
      });
    });
  }

  function initAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href'));
        if (t) {
          e.preventDefault();
          if (lenis) lenis.scrollTo(t, { offset: 0, duration: 1.4 });
          else t.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }

  function initAll() {
    initNav();
    if (reduced || !window.gsap || !window.ScrollTrigger) {
      initReduced();
      initAnchors();
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    if (!lenis && window.Lenis) {
      lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
    }
    initHero();
    initParallaxAndScene();
    initNotes();
    initCraft();
    initFades();
    initMagnetic();
    initAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme Editor: re-run choreography when the merchant edits a section */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      teardown();
      initAll();
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    });
    document.addEventListener('shopify:section:reorder', function () {
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    });
  }
})();
